// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdp-wrap {
  position: relative;
  width: 100%;
}

/* Room on the right for our icon (and the clear button when shown) */
.cui-control.cdp-control { /* paired with .cui-control: wins regardless of CSS load order */
  position: relative; /* containing block for the stretched picker button below */
  padding-right: 38px;
  cursor: pointer;
  appearance: none;
}

.cdp-wrap-clearable .cui-control.cdp-control {
  padding-right: 64px;
}

.cui-control.cdp-control:disabled {
  cursor: not-allowed;
}

/* Empty date inputs show grey "dd-mm-yyyy" like a placeholder */
.cui-control.cdp-empty {
  color: var(--cui-text-placeholder);
}

/* Native calendar button: invisible but stretched over the whole field,
   so clicking anywhere opens the picker (Chrome / Edge / Safari). */
.cdp-control::-webkit-calendar-picker-indicator {
  position: absolute;
  inset: 0;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}

.cdp-control:disabled::-webkit-calendar-picker-indicator {
  cursor: not-allowed;
}

.cdp-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  display: flex;
  transform: translateY(-50%);
  color: var(--cui-text-muted);
  pointer-events: none;
}

.cdp-wrap:focus-within .cdp-icon {
  color: var(--cui-primary);
}

.cdp-control.cui-control-error ~ .cdp-icon {
  color: var(--cui-danger);
}

.cdp-clear {
  position: absolute;
  top: 50%;
  right: 34px;
  z-index: 1; /* above the stretched native picker button */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--cui-text-muted);
  cursor: pointer;
  transition: background var(--cui-transition), color var(--cui-transition);
}

.cdp-clear:hover {
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomDatePicker/CustomDatePicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,qEAAqE;AACrE,2BAA2B,gEAAgE;EACzF,kBAAkB,EAAE,2DAA2D;EAC/E,mBAAmB;EACnB,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,kCAAkC;AACpC;;AAEA;oEACoE;AACpE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU,EAAE,6CAA6C;EACzD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B","sourcesContent":[".cdp-wrap {\n  position: relative;\n  width: 100%;\n}\n\n/* Room on the right for our icon (and the clear button when shown) */\n.cui-control.cdp-control { /* paired with .cui-control: wins regardless of CSS load order */\n  position: relative; /* containing block for the stretched picker button below */\n  padding-right: 38px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.cdp-wrap-clearable .cui-control.cdp-control {\n  padding-right: 64px;\n}\n\n.cui-control.cdp-control:disabled {\n  cursor: not-allowed;\n}\n\n/* Empty date inputs show grey \"dd-mm-yyyy\" like a placeholder */\n.cui-control.cdp-empty {\n  color: var(--cui-text-placeholder);\n}\n\n/* Native calendar button: invisible but stretched over the whole field,\n   so clicking anywhere opens the picker (Chrome / Edge / Safari). */\n.cdp-control::-webkit-calendar-picker-indicator {\n  position: absolute;\n  inset: 0;\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.cdp-control:disabled::-webkit-calendar-picker-indicator {\n  cursor: not-allowed;\n}\n\n.cdp-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  display: flex;\n  transform: translateY(-50%);\n  color: var(--cui-text-muted);\n  pointer-events: none;\n}\n\n.cdp-wrap:focus-within .cdp-icon {\n  color: var(--cui-primary);\n}\n\n.cdp-control.cui-control-error ~ .cdp-icon {\n  color: var(--cui-danger);\n}\n\n.cdp-clear {\n  position: absolute;\n  top: 50%;\n  right: 34px;\n  z-index: 1; /* above the stretched native picker button */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  transform: translateY(-50%);\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--cui-text-muted);\n  cursor: pointer;\n  transition: background var(--cui-transition), color var(--cui-transition);\n}\n\n.cdp-clear:hover {\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
